import api from '../token';

export const AddContacto = async (payload) => {
  try {
    const response = await api.post('/addContacto',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

